import type { PropsWithChildren } from "react";

import { WagmiProvider } from "wagmi";

import { config } from "./config";

export function Provider({ children }: PropsWithChildren) {
  return <WagmiProvider config={config}>{children}</WagmiProvider>;
}
